import React from 'react'
import { message } from 'antd'
import styles from './styles.module.scss'
import { CloseOutlined } from '@ant-design/icons'

const useCustomMessage = () => {
  const [messageApi, contextHolder] = message.useMessage()

  const openMessage = (type: 'success' | 'error' | 'info' | 'warning' | 'loading', content: string) => {
    const key = `message_${Date.now()}`

    messageApi.open({
      type,
      content: (
        <div>
          {content}
          <CloseOutlined style={{ marginLeft: '12px' }} onClick={() => messageApi.destroy(key)} />
        </div>
      ),
      className: styles.message,
      key,
    })
  }

  return { openMessage, contextHolder }
}

export default useCustomMessage
